import styled from "@emotion/styled/macro";
import { Popover, PopoverProps } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const ToolTip = styled(Popover)<IStyledComponentProps & PopoverProps>`
  &.tool-tip {
    border-radius: 0;

    h3.popover-header {
      background-color: ${({ theme }) => theme.colors.essential.white};
      border-bottom: 0 none;
      border-radius: 0;
    }

    .popover-body {
      padding-top: 0;
    }
  }
`;

export default { ToolTip };
